var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 1024,
    viewBox: "0 0 649 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_1324",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 649,
    height: 1024
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.5,
    cy: 512,
    rx: 324.5,
    ry: 512,
    fill: "url(#paint0_radial_106_1324)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_1324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.713 512C344.713 521.176 342.355 529.46 338.568 535.434C334.778 541.414 329.604 545.019 323.969 545.019C318.334 545.019 313.16 541.414 309.37 535.434C305.583 529.46 303.225 521.176 303.225 512C303.225 502.824 305.583 494.54 309.37 488.566C313.16 482.586 318.334 478.981 323.969 478.981C329.604 478.981 334.778 482.586 338.568 488.566C342.355 494.54 344.713 502.824 344.713 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.579 512C376.579 535.06 370.654 555.913 361.101 570.986C351.544 586.065 338.404 595.297 323.969 595.297C309.534 595.297 296.394 586.065 286.837 570.986C277.284 555.913 271.359 535.06 271.359 512C271.359 488.94 277.284 468.087 286.837 453.014C296.394 437.935 309.534 428.703 323.969 428.703C338.404 428.703 351.544 437.935 361.101 453.014C370.654 468.087 376.579 488.94 376.579 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.444 512C408.444 548.944 398.953 582.367 383.633 606.538C368.31 630.715 347.203 645.575 323.969 645.575C300.735 645.575 279.628 630.715 264.305 606.538C248.985 582.367 239.494 548.944 239.494 512C239.494 475.056 248.985 441.633 264.305 417.462C279.628 393.285 300.735 378.425 323.969 378.425C347.203 378.425 368.31 393.285 383.633 417.462C398.953 441.633 408.444 475.056 408.444 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.31 512C440.31 562.828 427.252 608.82 406.166 642.09C385.076 675.366 356.003 695.854 323.969 695.854C291.935 695.854 262.862 675.366 241.772 642.09C220.686 608.82 207.628 562.828 207.628 512C207.628 461.172 220.686 415.18 241.772 381.91C262.862 348.634 291.935 328.146 323.969 328.146C356.003 328.146 385.076 348.634 406.166 381.91C427.252 415.18 440.31 461.172 440.31 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.176 512C472.176 576.712 455.551 635.274 428.698 677.642C401.842 720.017 364.802 746.132 323.969 746.132C283.136 746.132 246.096 720.017 219.239 677.642C192.387 635.274 175.762 576.712 175.762 512C175.762 447.288 192.387 388.726 219.239 346.358C246.096 303.983 283.136 277.868 323.969 277.868C364.802 277.868 401.842 303.983 428.698 346.358C455.551 388.726 472.176 447.288 472.176 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.042 512C504.042 590.596 483.85 661.727 451.231 713.194C418.608 764.667 373.601 796.41 323.969 796.41C274.336 796.41 229.33 764.667 196.707 713.194C164.088 661.727 143.896 590.596 143.896 512C143.896 433.404 164.088 362.273 196.707 310.806C229.33 259.333 274.336 227.59 323.969 227.59C373.601 227.59 418.608 259.333 451.231 310.806C483.85 362.273 504.042 433.404 504.042 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.908 512C535.908 604.48 512.149 688.181 473.763 748.746C435.374 809.318 382.401 846.688 323.969 846.688C265.537 846.688 212.564 809.318 174.174 748.746C135.789 688.181 112.03 604.48 112.03 512C112.03 419.52 135.789 335.819 174.174 275.254C212.564 214.682 265.537 177.312 323.969 177.312C382.401 177.312 435.374 214.682 473.763 275.254C512.149 335.819 535.908 419.52 535.908 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.773 512C567.773 618.364 540.448 714.634 496.296 784.298C452.14 853.968 391.2 896.966 323.969 896.966C256.737 896.966 195.798 853.968 151.642 784.298C107.49 714.634 80.1644 618.364 80.1644 512C80.1644 405.636 107.49 309.366 151.642 239.702C195.798 170.032 256.737 127.034 323.969 127.034C391.2 127.034 452.14 170.032 496.296 239.702C540.448 309.366 567.773 405.636 567.773 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.639 512C599.639 632.248 568.747 741.088 518.828 819.85C468.906 898.619 400 947.245 323.969 947.245C247.938 947.245 179.032 898.619 129.109 819.85C79.1905 741.088 48.2987 632.248 48.2987 512C48.2987 391.753 79.1905 282.912 129.109 204.15C179.032 125.381 247.938 76.7554 323.969 76.7554C400 76.7554 468.906 125.381 518.828 204.15C568.747 282.912 599.639 391.753 599.639 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.883 512C620.883 641.503 587.613 758.723 533.85 843.552C480.083 928.386 405.866 980.763 323.969 980.763C242.071 980.763 167.855 928.386 114.088 843.552C60.3244 758.723 27.0548 641.503 27.0548 512C27.0548 382.496 60.3244 265.277 114.088 180.448C167.855 95.6138 242.071 43.2365 323.969 43.2365C405.866 43.2365 480.083 95.6138 533.85 180.448C587.613 265.277 620.883 382.496 620.883 512Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.5 512C648.5 653.305 612.199 781.209 553.534 873.771C494.865 966.339 413.877 1023.5 324.5 1023.5C235.123 1023.5 154.135 966.339 95.4662 873.771C36.8013 781.209 0.5 653.305 0.5 512C0.5 370.695 36.8013 242.791 95.4662 150.229C154.135 57.6607 235.123 0.5 324.5 0.5C413.877 0.5 494.865 57.6607 553.534 150.229C612.199 242.791 648.5 370.695 648.5 512Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_106_1324",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.5 512) rotate(90) scale(512 324.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.2f0c0e1f7f1a25005864ae988dcb8c14.svg";
export { ForwardRef as ReactComponent };